(function (module) {
    'use strict';

    module.config(['formlyConfigProvider', (formlyConfigProvider) => {
        formlyConfigProvider.setType({
            name: 'moment-schedule-time-select',
            template: `
                <div class="moment-schedule-time-select">
                    <md-input-container>
                      <input ng-model="model[options.key]" type="time" required>
                    </md-input-container>
                </div>
            `,
            controller: ['$scope', '$q', ($scope, $q) => {
            }],
        });
    }]);
})(angular.module('rocket.components'));

